/* ----------------------------------------------------------------------------
updates UI when a price plan is selected
---------------------------------------------------------------------------- */

export default class PlanPicker extends HTMLElement {
  updateSelected(eventElement) {
    const selectedButton = eventElement;
    const currentButton = this.querySelector('[aria-current]');
    currentButton.removeAttribute('aria-current');
    selectedButton.setAttribute('aria-current', true);
  }

  updatePrice(eventElement) {
    const selectedButton = eventElement;
    this.priceBlocks.forEach((element) => {
      const block = element;
      if (block.getAttribute('data-price-block') === selectedButton.getAttribute('data-plan')) {
        block.classList.remove('hidden');
      } else {
        block.classList.add('hidden');
      }
    });
    this.ctaButtons.forEach((element) => {
      const currentCtaButton = element;
      if (selectedButton.getAttribute('data-cta') === currentCtaButton.getAttribute('data-cta-button')) {
        currentCtaButton.classList.remove('hidden');
      } else {
        currentCtaButton.classList.add('hidden');
      }
    });
  }

  updateFeatureCards(eventElement) {
    const selectedButton = eventElement;
    const planName = eventElement.getAttribute('data-plan');
    this.featureCards.forEach((element) => {
      const currentCard = element;
      const currentCardPlan = currentCard.getAttribute('data-minimum-plan');
      if (planName === currentCardPlan) {
        currentCard.classList.remove('--disabled');
      } else if (planName === 'enterprise' && currentCardPlan === 'corporate') {
        currentCard.classList.remove('--disabled');
      } else if (planName === 'enterprise' && currentCardPlan === 'premium') {
        currentCard.classList.remove('--disabled');
      } else if (planName === 'corporate' && currentCardPlan === 'premium') {
        currentCard.classList.remove('--disabled');
      } else {
        currentCard.classList.add('--disabled');
      }
    });
  }

  updateSavingsPreview(eventElement) {
    const selectedButton = eventElement;
    const savingsPreview = this.querySelector('savings-preview');
    savingsPreview.setAttribute('price', selectedButton.getAttribute('data-price'));
    savingsPreview.setAttribute('headcount', selectedButton.getAttribute('data-median'));
  }

  clickable() {
    this.planButtons.forEach((element) => {
      element.addEventListener('click', (e) => {
        this.updateSelected(element);
        this.updatePrice(element);
        this.updateFeatureCards(element);
        this.updateSavingsPreview(element);
      });
    });
  }

  connectedCallback() {
    this.planButtons = this.querySelectorAll('[data-plan]');
    this.featureCards = this.querySelectorAll('[data-minimum-plan]');
    this.priceBlocks = this.querySelectorAll('[data-price-block]');
    this.ctaButtons = this.querySelectorAll('[data-cta-button]');
    this.clickable();
  }
}

window.customElements.define('plan-picker', PlanPicker);
